export default {
    prescribed_fire: {
        name: "Prescribed Fire",
        url: "nwcg_polygons_fire/prescribed_fire",
    },
    wildfire_daily_fire_perimeter: {
        name: "Wildfire Daily Fire Perimeter",
        url: "nwcg_polygons_fire/wildfire_daily_fire_perimeter",
    },
}
